import { request } from '../request'

/**
 * 登录
 * @param username
 * @param password
 */
export function login(username, password) {
    return request({
        url: "/agg-portal/ap/sso/login",
        method: 'post',
        params: { username: username, password: password}
    });
}

/**
 * 手机登录
 * @param username
 * @param password
 */
export function phoneLogin(telephone, authCode) {
    return request({
        url: "/agg-portal/ap/sso/phoneLogin",
        method: 'post',
        params: {
            telephone: telephone,
            authCode: authCode
        }
    });
}


/**
 * 注册
 * @param params
 * @returns {AxiosPromise}
 */
export function register(params) {
    return request({
        url: "/agg-portal/ap/sso/register",
        method: 'post',
        params: params
    });
}

/**
 * 更改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function updatePassword(params) {
    return request({
        url: "/agg-portal/ap/sso/updatePassword",
        method: 'post',
        params: params
    });
}

/**
 * 获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function getCodeTelephone(telephone) {
    return request({
        url: "/agg-portal/ap/sso/getCode",
        method: 'get',
        params:{
            authCode:"getcode",
            telephone:telephone
        }
    });
}

/**
 * 微信登录
 * @param code
 * @returns {AxiosPromise}
 */
export function wxLogin(code) {
    return request({
        url: "/agg-portal/ap/sso/wxLogin",
        method: 'get',
        params : { code: code }
    });
}

